var Dicts = {

    documentStatuses: {
        UNREVIEWED: 'Not Assigned',
        IN_REVIEW: 'Review Pending',
        SIGNED: 'Signed',
        VIEWED: 'Viewed',
        DELETED: 'Obsolete',
        UNDER_REVIEW: 'Under Review'
    },

    reviewerStatuses: {
        UNREVIEWED: 'Review Pending',
        IN_REVIEW: 'Review Pending',
        SIGNED: 'Signed',
        VIEWED: 'Viewed',
        DELETED: 'Obsolete',
        UNDER_REVIEW: 'Under Review'
    },

    documentIntention: {
        UNASSIGNED: 'Not Assigned',
        TO_SIGN: 'Signature',
        TO_VIEW: 'Review'
    },

    medicationEventTypes: {
        PRESCRIPTION: 'PRESCRIPTION',
        ANOTHER_APPOINTMENT: 'ANOTHER APPOINTMENT',
        PURCHASE: 'PURCHASE',
        TAKEN_INSIDE: 'TAKEN'
    },

    housingValues: ['Alone',
        'With relative or friend',
        'Hospital',
        'Personal care home',
        'Nursing home',
        'Other'],

    martialStatuses:
        [
            {name: "annulled", value: "Annulled"},
            {name: "divorced", value: "Divorced"},
            {name: "interlocutory", value: "Interlocutory"},
            {name: "legally-separated", value: "Legally Separated"},
            {name: "married", value: "Married"},
            {name: "polygamous", value: "Polygamous"},
            {name: "never-married", value: "Never Married"},
            {name: "domestic-partner", value: "Domestic partner"},
            {name: "unmarried", value: "Unmarried"},
            {name: "widowed", value: "Widowed"},
            {name: "unknown", value: "Unknown"}
        ],

    determinationOfNeedRevised: [
        {function: "Eating", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Bathing", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Grooming", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Dressing", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Transferring", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Continence", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Managing Money", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Telephoning", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Preparing Meals", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Laundry", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Housework", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Outside Home", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Routine Health", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Special Health", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {function: "Being Alone", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
        {
            function: "Total 1-6 (ADL)",
            levelOfImpairment: 0,
            unmetNeedForCare: 0,
            comment: "",
            editable: false,
            start: 0,
            stop: 5
        },
        {
            function: "Total 7-15 (IADL)",
            levelOfImpairment: 0,
            unmetNeedForCare: 0,
            comment: "",
            editable: false,
            start: 6,
            stop: 14
        },
        {
            function: "Total 1-15 (ADL + IADL)",
            levelOfImpairment: 0,
            unmetNeedForCare: 0,
            comment: "",
            editable: false,
            start: 0,
            stop: 14
        }
    ],

    contactPriorities: {
        0: '1-st Priority',
        1: '2-d Priority',
        5: '3-d Priority',
        8: '4-d Priority',
        9: 'Last Priority'
    },

    contactTypes: {
        "EMAIL": "Email",
        "FAX": "Fax",
        "HAND_DELIVERY": "Hand delivery",
        "MEDICITY": "Medicity",
        "PHONE": "Phone",
        "REVIEW_AND_SIGN": "Review and sign"
    },

    addressUsages: {
        "H": "Home",
        "WP": "Work Place",
        "TMP": "Temporary",
        "AS": "Answering service",
        "EC": "Emergency contact",
        "MC": "Mobile contact"
    },

    hl7Dict: {
        "2.16.840.1.113883.6.88": "RxNorm",
        "2.16.840.1.113883.6.90": "ICD-10",
        "2.16.840.1.113883.6.96": "SNOMED ST",
        "2.16.840.1.113883.6.103": "ICD-9"
    },

    documentTypes: {
        pdf: "PDF",
        xml: "XML",
        txt: "TXT",
        jpg: "JPG"
    }
};

module.exports = Dicts;


//////////////////
// WEBPACK FOOTER
// ./app/data/dicts.js
// module id = 193
// module chunks = 0